module.exports = __webpack_public_path__ + "assets/img/delete_0.a9516e1d.svg";